import { supabase, supabaseUrl, supabaseAnonKey } from './supabase'

/**
 * Invoke Supabase Edge Functions from the browser (with user JWT + anon apikey).
 * @param {string} name Function slug, e.g. run-sweep
 * @param {RequestInit} init Pass method, body; Authorization merged from session if omitted.
 */
export async function invokeEdgeFunction(name, init = {}) {
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Supabase URL / anon key missing')
  }
  const url = `${supabaseUrl.replace(/\/$/, '')}/functions/v1/${name}`
  const session = (await supabase.auth.getSession()).data.session
  const token = session?.access_token
  if (!token) throw new Error('Not authenticated')

  const headers = new Headers(init.headers || {})
  headers.set('Authorization', headers.get('Authorization') || `Bearer ${token}`)
  headers.set('apikey', supabaseAnonKey)
  if (!headers.has('Content-Type') && init.body && !(init.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json')
  }

  return fetch(url, { ...init, headers })
}
